import React from 'react'

import { URL_BP_REGISTRATION } from 'src/config/url'

import styles from './BPReconfirmationClose.module.scss'

export const BPReconfirmationClose = () => (
  <div className={styles.root}>
    <p>
      Thank you for your interest in reconfirming the Business Partner Program – FY23 Terms and
      Conditions.
    </p>

    <p>Unfortunately, this process is no longer available.</p>

    <p>
      If you are interested in renewing your Business Partner membership, you will be able to{' '}
      <a href={URL_BP_REGISTRATION}>re-register</a> starting Nov. 7th.
    </p>
  </div>
)
